<!-- @format -->

<template>
    <div
        class="gst-notification-card d-flex flex-row px-2 py-3"
        :class="`gst-notification-card--${type}`">
        <BaseIcon
            :symbol-id="icon"
            class="mr-2"
            width="20"
            height="20" />
        <slot></slot>
        <BaseButton
            v-if="canClose"
            text
            class="close-btn px-0 float-right ml-auto"
            @click="closeNotification">
            <BaseIcon
                v-if="icon"
                class="ml-3 mr-2"
                symbol-id="icons--close"
                width="12"
                height="12" />
        </BaseButton>
    </div>
</template>

<script>
const NOTIFICATION_TYPES = {
    ERROR: 'error',
    WARNING: 'warning',
    INFO: 'info',
};

const NOTIFICATION_ICONS = {
    [NOTIFICATION_TYPES.ERROR]: 'icons--exclamation_round',
    [NOTIFICATION_TYPES.WARNING]: 'icons--warning',
    [NOTIFICATION_TYPES.INFO]: null,
};

export default {
    name: 'NotificationCard',
    props: {
        type: {
            type: String,
            default: NOTIFICATION_TYPES.ERROR,
            validator: (value) => Object.values(NOTIFICATION_TYPES).includes(value),
        },
        canClose: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        icon() {
            return NOTIFICATION_ICONS[this.type];
        },
    },
    methods: {
        closeNotification() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss">
@import '@scssVariables';
@import '@scssMixins';

.gst-notification-card {
    font-size: font-size('xs');
}

.gst-notification-card.gst-notification-card--error {
    background-color: rgba(theme-color-hex('error'), 0.15);

    svg {
        height: 20px;
        width: 20px;
    }
}

.gst-notification-card.gst-notification-card--warning {
    background-color: rgba(theme-color-hex('warning'), 0.15);

    .close-btn {
        margin: theme-spacing(n2);
        min-width: 20px;

        .gst-svg-icon {
            fill: theme-color('new-tertiary') !important;
        }
    }
}

@include desktop-only {
    .gst-notification-card {
        font-size: font-size('s');
    }

    .gst-notification-card.gst-notification-card--error {
        svg {
            height: 24px;
            width: 24px;
        }
    }
}
</style>
